import { render, staticRenderFns } from "./BuyHint.vue?vue&type=template&id=7c36a4e4&scoped=true&"
import script from "./BuyHint.vue?vue&type=script&lang=js&"
export * from "./BuyHint.vue?vue&type=script&lang=js&"
import style0 from "./BuyHint.vue?vue&type=style&index=0&id=7c36a4e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c36a4e4",
  null
  
)

component.options.__file = "BuyHint.vue"
export default component.exports